const barChart = (data) => {
    var valores = [];
    var nome = [];
    var soma = 0;
    data.forEach((el) => {
        soma += el.valor;
        valores.push(el.valor);
        nome.push(el.nome);
    });
    return {
        series: [{
            name: "Despesas",
            data: valores
        }],
        chartOptions: {
            chart: {
                toolbar: {
                    show: false,
                }
            },
            plotOptions: {
                bar: {
                    horizontal: true,
                }
            },
            dataLabels: {
                enabled: false
            },
            colors: ['#34c38f'],
            grid: {
                borderColor: '#f1f1f1',
            },
            xaxis: {
                categories: nome,
            },
            yaxis: {
                title: {
                    text: 'Despesas',
                }
            },
            tooltip: {
                shared: true,
                intersect: false,
                y: {
                    formatter: function (y) {
                        if (typeof y !== "undefined") {
                            return "R$" + y + " | " + ((y / soma) * 100).toFixed(1) + "%";
                        }
                        return y;

                    }
                }
            },
        }
    };
}
const mixedChart = (mesParam, despesas, limite, qtde) => {

    var despesaMax = Math.max(...despesas);
    var limiteMax = Math.max(...limite);
    var max = despesaMax > limiteMax ? despesaMax : limiteMax;
    var qtdeMax = Math.max(...qtde);
    var meses = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];
    var mesesAux = [];
    mesParam.forEach((el) => {
        mesesAux.push(meses[el - 1]);
    });
    return {
        series: [{
            name: 'Total Despesas',
            type: 'column',
            data: despesas
        }, {
            name: 'Limite Global',
            type: 'area',
            data: limite
        }, {
            name: 'Qtde',
            type: 'line',
            data: qtde
        }],
        chartOptions: {
            chart: {
                stacked: false,
                toolbar: {
                    show: false
                }
            },
            stroke: {
                width: [0, 2, 4],
                curve: 'smooth'
            },
            plotOptions: {
                bar: {
                    columnWidth: '50%'
                }
            },
            colors: ['#f46a6a', '#556ee6', '#34c38f'],
            fill: {
                opacity: [0.85, 0.25, 1],
                gradient: {
                    inverseColors: false,
                    shade: 'light',
                    type: "vertical",
                    opacityFrom: 0.85,
                    opacityTo: 0.55,
                    stops: [0, 100, 100, 100]
                }
            },
            labels: ['01/01/2003', '02/01/2003', '03/01/2003', '04/01/2003', '05/01/2003', '06/01/2003', '07/01/2003', '08/01/2003', '09/01/2003', '10/01/2003', '11/01/2003'],
            markers: {
                size: 0
            },
            xaxis: {
                categories: mesesAux
            },
            yaxis: [
                {
                    min: 0,
                    max: max,
                    title: {
                        text: 'Despesas',
                    }
                },
                {
                    min: 0,
                    max: max,
                    show: false,
                    title: {
                        text: 'limite',
                    }
                },
                {
                    min: 0,
                    max: qtdeMax,
                    forceNiceScale: true,
                    opposite: true,
                    title: {
                        text: "Qtde"
                    }
                }
            ],
            tooltip: {
                shared: true,
                intersect: false,
                y:
                    [
                        {
                            formatter: function (y) {
                                if (typeof y !== "undefined") {
                                    return "R$" + y;
                                }
                                return y;

                            }
                        },
                        {
                            formatter: function (y) {
                                if (typeof y !== "undefined") {
                                    return "R$" + y;
                                }
                                return y;

                            }
                        },
                        {
                            formatter: function (y) {
                                if (typeof y !== "undefined") {
                                    return y;
                                }
                                return y;

                            }
                        }
                    ]
            },
            grid: {
                borderColor: '#f1f1f1'
            }
        }
    }
};
const mixedChartMensal = (coopParam, despesas, limite) => {
    var despesaMax = Math.max(...despesas);
    return {
        series: [{
            name: 'Total Despesas',
            type: 'column',
            data: despesas
        }, {
            name: 'Limite Global',
            type: 'area',
            data: limite
        }],
        chartOptions: {
            chart: {
                stacked: false,
                toolbar: {
                    show: false
                }
            },
            stroke: {
                width: [0, 2, 4],
                curve: 'smooth'
            },
            plotOptions: {
                bar: {
                    columnWidth: '50%'
                }
            },
            colors: ['#f46a6a', '#556ee6', '#34c38f'],
            fill: {
                opacity: [0.85, 0.25, 1],
                gradient: {
                    inverseColors: false,
                    shade: 'light',
                    type: "vertical",
                    opacityFrom: 0.85,
                    opacityTo: 0.55,
                    stops: [0, 100, 100, 100]
                }
            },
            labels: ['01/01/2003', '02/01/2003', '03/01/2003', '04/01/2003', '05/01/2003', '06/01/2003', '07/01/2003', '08/01/2003', '09/01/2003', '10/01/2003', '11/01/2003'],
            markers: {
                size: 0
            },
            xaxis: {
                categories: coopParam
            },
            yaxis: [
                {
                    min: 0,
                    max: despesaMax,
                    title: {
                        text: 'Despesas',
                    }
                },
                {
                    min: 0,
                    max: despesaMax,
                    show: false,
                    title: {
                        text: 'limite',
                    }
                }
            ],
            tooltip: {
                shared: true,
                intersect: false,
                y: {
                    formatter: function (y) {
                        if (typeof y !== "undefined") {
                            return "R$" + y;
                        }
                        return y;

                    }
                }
            },
            grid: {
                borderColor: '#f1f1f1'
            }
        }
    }
};

export { barChart, mixedChart, mixedChartMensal };